import { merge } from 'lodash';
import { BigQueryEventGroup, BIG_QUERY_EVENT_BASE_OPTIONS } from './constants';

export * from './constants';

/**
 * BigQuery event creator `createBigQueryEvent` options interface.
 */
export interface CreateBigQueryEventOptions {
    [key: string]: CreateBigQueryEventOptions | Date | string | number;
}

/**
 * Create BigQuery event object by group and options enriched with base options.
 */
export const createBigQueryEvent = (
    group: BigQueryEventGroup,
    options: CreateBigQueryEventOptions
) => merge({ group, ...options }, BIG_QUERY_EVENT_BASE_OPTIONS);
